/* =========================================================
   Leuhs — global.js
   Vanilla JS, no dependencies. Progressive enhancement:
   every feature degrades to a working non-JS fallback.
   ========================================================= */
(function () {
  'use strict';

  /* ---------- Utilities ---------- */
  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return format
      .replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }

  var toastTimer;
  function toast(message) {
    var el = document.getElementById('Toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'Toast';
      el.className = 'toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  function trapFocus(container) {
    var focusable = container.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    container.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- Drawers ---------- */
  var openDrawer = null;
  var lastTrigger = null;

  function setDrawerState(drawer, open, trigger) {
    if (!drawer) return;
    if (open) {
      if (openDrawer && openDrawer !== drawer) setDrawerState(openDrawer, false);
      drawer.classList.add('is-open');
      drawer.removeAttribute('aria-hidden');
      document.body.classList.add('drawer-open');
      openDrawer = drawer;
      lastTrigger = trigger || null;
      var focusTarget = drawer.querySelector('[data-autofocus]') || drawer.querySelector('button, a, input');
      if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 80);
      trapFocus(drawer);
    } else {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
      if (openDrawer === drawer) openDrawer = null;
      if (lastTrigger) { lastTrigger.focus(); lastTrigger = null; }
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      setDrawerState(document.getElementById(opener.getAttribute('data-drawer-open')), true, opener);
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      setDrawerState(closer.closest('.drawer') || openDrawer, false);
      return;
    }
    if (e.target.closest('[data-overlay-backdrop]')) {
      setDrawerState(openDrawer, false);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (openDrawer) setDrawerState(openDrawer, false);
      var zoom = document.querySelector('.media-zoom');
      if (zoom) zoom.remove();
    }
  });

  /* ---------- Sticky header shadow ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Announcement bar ---------- */
  document.querySelectorAll('[data-announcement-bar]').forEach(function (bar) {
    var slides = bar.querySelectorAll('.announcement-bar__slide');
    if (slides.length > 1) {
      var index = 0;
      var interval = parseInt(bar.getAttribute('data-interval'), 10) || 5000;
      setInterval(function () {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      }, interval);
    }
    bar.querySelectorAll('[data-countdown]').forEach(function (el) {
      var end = new Date(el.getAttribute('data-countdown')).getTime();
      if (isNaN(end)) return;
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) { el.textContent = '00:00:00'; return; }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var pad = function (n) { return String(n).padStart(2, '0'); };
        el.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
        setTimeout(tick, 1000);
      }
      tick();
    });
  });

  /* ---------- Quantity inputs ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty__btn');
    if (!btn) return;
    var input = btn.closest('.qty').querySelector('.qty__input');
    var value = parseInt(input.value, 10) || 0;
    var min = parseInt(input.min, 10);
    if (isNaN(min)) min = 0;
    value += btn.hasAttribute('data-qty-plus') ? 1 : -1;
    if (value < min) value = min;
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.toggleAttribute('hidden', count === 0);
    });
  }

  function refreshCartDrawer(openAfter) {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (!html) return;
        var dom = new DOMParser().parseFromString(html, 'text/html');
        var fresh = dom.querySelector('#CartDrawer');
        var current = document.querySelector('#CartDrawer');
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          var count = parseInt(fresh.getAttribute('data-item-count'), 10) || 0;
          current.setAttribute('data-item-count', count);
          updateCartCount(count);
        }
        if (openAfter && current) setDrawerState(current, true);
      })
      .catch(function () { /* non-blocking */ });
  }

  function addToCart(body, button) {
    if (button) { button.classList.add('btn--loading'); button.setAttribute('aria-disabled', 'true'); }
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(res.data.description || res.data.message || window.theme.strings.cartError);
          return;
        }
        return refreshCartDrawer(true);
      })
      .catch(function () { toast(window.theme.strings.cartError); })
      .finally(function () {
        if (button) { button.classList.remove('btn--loading'); button.removeAttribute('aria-disabled'); }
      });
  }

  // Product form submit (main product + quick add forms)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var props = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (input) {
      var key = input.name.slice(11, -1);
      if (input.value) props[key] = input.value;
    });
    var payload = {
      items: [{
        id: parseInt(idInput.value, 10),
        quantity: qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1,
        properties: props
      }]
    };
    var sellingPlan = form.querySelector('[name="selling_plan"]:checked, select[name="selling_plan"]');
    if (sellingPlan && sellingPlan.value) payload.items[0].selling_plan = sellingPlan.value;
    addToCart(payload, form.querySelector('[type="submit"]'));
  });

  // Cart line quantity / removal — works in drawer and on cart page
  function changeLine(line, quantity, scope) {
    if (scope) scope.style.opacity = '0.5';
    fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        } else {
          refreshCartDrawer(false);
          updateCartCount(cart.item_count);
        }
      })
      .catch(function () {
        toast(window.theme.strings.cartError);
        if (scope) scope.style.opacity = '';
      });
  }

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(parseInt(remove.getAttribute('data-line'), 10), 0, remove.closest('.cart-item'));
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (input) {
      changeLine(parseInt(input.getAttribute('data-line'), 10), parseInt(input.value, 10) || 0, input.closest('.cart-item'));
    }
    var note = e.target.closest('[data-cart-note]');
    if (note) {
      fetch(window.routes.cart_update_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    }
  });

  // Quick add (single-variant products)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    addToCart({ items: [{ id: parseInt(btn.getAttribute('data-quick-add'), 10), quantity: 1 }] }, btn);
  });

  /* ---------- Variant picker ---------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var sectionEl = picker.closest('[data-product-section]');
    if (!sectionEl) return;
    var jsonEl = sectionEl.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var form = sectionEl.querySelector('form[data-product-form]');
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var priceEl = sectionEl.querySelector('[data-price-wrapper]');
    var atcBtn = form ? form.querySelector('[data-atc-button]') : null;
    var atcLabel = atcBtn ? atcBtn.querySelector('[data-atc-label]') : null;
    var stickyPrice = sectionEl.querySelector('[data-sticky-price]');

    function selectedOptions() {
      var options = [];
      picker.querySelectorAll('[data-option-index]').forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var checked = group.querySelector('input:checked');
        var select = group.querySelector('select');
        options[idx] = checked ? checked.value : (select ? select.value : null);
      });
      return options;
    }

    function findVariant(options) {
      return product.variants.find(function (v) {
        return v.options.every(function (value, i) { return value === options[i]; });
      });
    }

    function renderPrice(variant) {
      if (!priceEl) return;
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html = '<span class="price__sale">' + formatMoney(variant.price) + '</span>' +
               '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
      } else {
        html = '<span>' + formatMoney(variant.price) + '</span>';
      }
      priceEl.innerHTML = html;
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
    }

    function updateMedia(variant) {
      if (!variant.featured_media) return;
      var slide = sectionEl.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
      var viewport = sectionEl.querySelector('.product-gallery__viewport');
      if (slide && viewport) viewport.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }

    function update() {
      var variant = findVariant(selectedOptions());
      if (idInput && variant) idInput.value = variant.id;
      if (atcBtn) {
        if (!variant) {
          atcBtn.setAttribute('disabled', '');
          if (atcLabel) atcLabel.textContent = window.theme.strings.unavailable;
        } else if (!variant.available) {
          atcBtn.setAttribute('disabled', '');
          if (atcLabel) atcLabel.textContent = window.theme.strings.soldOut;
        } else {
          atcBtn.removeAttribute('disabled');
          if (atcLabel) atcLabel.textContent = window.theme.strings.addToCart;
        }
      }
      picker.querySelectorAll('[data-option-value-label]').forEach(function (label) {
        var idx = parseInt(label.getAttribute('data-option-value-label'), 10);
        var options = selectedOptions();
        label.textContent = options[idx] || '';
      });
      if (variant) {
        renderPrice(variant);
        updateMedia(variant);
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
    }

    picker.addEventListener('change', update);
  });

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var viewport = gallery.querySelector('.product-gallery__viewport');
    var slides = gallery.querySelectorAll('.product-gallery__slide');
    var thumbs = gallery.querySelectorAll('.product-gallery__thumb');
    var counter = gallery.querySelector('[data-gallery-counter]');

    function setActive(index) {
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        viewport.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        setActive(i);
      });
    });

    if (viewport && slides.length > 1) {
      var ticking = false;
      viewport.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var index = Math.round(viewport.scrollLeft / viewport.clientWidth);
          setActive(Math.min(index, slides.length - 1));
          ticking = false;
        });
      }, { passive: true });
    }

    // Zoom
    gallery.addEventListener('click', function (e) {
      var frame = e.target.closest('[data-zoom-src]');
      if (!frame) return;
      var overlay = document.createElement('div');
      overlay.className = 'media-zoom';
      overlay.innerHTML = '<img src="' + frame.getAttribute('data-zoom-src') + '" alt="">' +
        '<button class="icon-btn media-zoom__close" aria-label="Close">' +
        '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 2l12 12M14 2L2 14"/></svg></button>';
      overlay.addEventListener('click', function () { overlay.remove(); });
      document.body.appendChild(overlay);
    });
  });

  /* ---------- Sticky add to cart (mobile) ---------- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var buyButtons = document.querySelector('[data-buy-buttons]');
  if (stickyBar && buyButtons && 'IntersectionObserver' in window) {
    var atcObserver = new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 });
    atcObserver.observe(buyButtons);
    var stickyBtn = stickyBar.querySelector('[data-sticky-submit]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = document.querySelector('form[data-product-form]');
        if (form) form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }
  }

  /* ---------- Predictive search ---------- */
  var searchInput = document.querySelector('[data-predictive-input]');
  var searchResults = document.querySelector('[data-predictive-results]');
  if (searchInput && searchResults) {
    var searchTimer;
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var query = searchInput.value.trim();
      if (query.length < 2) { searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        fetch(window.routes.predictive_search_url + '?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var dom = new DOMParser().parseFromString(html, 'text/html');
            var inner = dom.querySelector('#PredictiveSearchResults');
            searchResults.innerHTML = inner ? inner.innerHTML : '';
          })
          .catch(function () { /* silent */ });
      }, 280);
    });
  }

  /* ---------- Wishlist (localStorage) ---------- */
  var WISHLIST_KEY = 'leuhs:wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }
  function setWishlist(items) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(items)); } catch (e) { /* private mode */ }
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = items.length;
      el.toggleAttribute('hidden', items.length === 0);
    });
  }
  function syncWishlistButtons() {
    var items = getWishlist();
    document.querySelectorAll('.wishlist-toggle').forEach(function (btn) {
      btn.classList.toggle('is-active', items.indexOf(btn.getAttribute('data-handle')) > -1);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wishlist-toggle');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-handle');
    var items = getWishlist();
    var index = items.indexOf(handle);
    if (index > -1) items.splice(index, 1); else items.push(handle);
    setWishlist(items);
    syncWishlistButtons();
  });
  setWishlist(getWishlist());
  syncWishlistButtons();

  // Wishlist page renderer
  var wishlistGrid = document.querySelector('[data-wishlist-grid]');
  if (wishlistGrid) {
    var handles = getWishlist();
    var emptyEl = document.querySelector('[data-wishlist-empty]');
    if (!handles.length) {
      if (emptyEl) emptyEl.removeAttribute('hidden');
    } else {
      handles.forEach(function (handle) {
        fetch('/products/' + handle + '?section_id=product-card-standalone')
          .then(function (r) { if (!r.ok) throw new Error(); return r.text(); })
          .then(function (html) {
            var dom = new DOMParser().parseFromString(html, 'text/html');
            var card = dom.querySelector('.product-card');
            if (card) wishlistGrid.appendChild(card);
            syncWishlistButtons();
          })
          .catch(function () { /* product removed */ });
      });
    }
  }

  /* ---------- Recently viewed ---------- */
  var RECENT_KEY = 'leuhs:recently-viewed';
  var productMeta = document.querySelector('[data-current-product-handle]');
  if (productMeta) {
    try {
      var recent = JSON.parse(localStorage.getItem(RECENT_KEY)) || [];
      var handle = productMeta.getAttribute('data-current-product-handle');
      recent = recent.filter(function (h) { return h !== handle; });
      recent.unshift(handle);
      localStorage.setItem(RECENT_KEY, JSON.stringify(recent.slice(0, 12)));
    } catch (e) { /* ignore */ }
  }
  var recentGrid = document.querySelector('[data-recently-viewed-grid]');
  if (recentGrid) {
    var recentHandles = [];
    try { recentHandles = JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (e) { /* ignore */ }
    var currentHandle = productMeta ? productMeta.getAttribute('data-current-product-handle') : null;
    recentHandles = recentHandles.filter(function (h) { return h !== currentHandle; })
      .slice(0, parseInt(recentGrid.getAttribute('data-limit'), 10) || 4);
    if (!recentHandles.length) {
      var sectionWrap = recentGrid.closest('.section');
      if (sectionWrap) sectionWrap.setAttribute('hidden', '');
    } else {
      var sectionShow = recentGrid.closest('.section');
      if (sectionShow) sectionShow.removeAttribute('hidden');
      recentHandles.forEach(function (h) {
        fetch('/products/' + h + '?section_id=product-card-standalone')
          .then(function (r) { if (!r.ok) throw new Error(); return r.text(); })
          .then(function (html) {
            var dom = new DOMParser().parseFromString(html, 'text/html');
            var card = dom.querySelector('.product-card');
            if (card) recentGrid.appendChild(card);
            syncWishlistButtons();
          })
          .catch(function () { /* ignore */ });
      });
    }
  }

  /* ---------- Carousels (scroll rows with arrow nav) ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (wrap) {
    var row = wrap.querySelector('.scroll-row');
    if (!row) return;
    wrap.querySelectorAll('[data-carousel-prev], [data-carousel-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var amount = row.firstElementChild ? row.firstElementChild.getBoundingClientRect().width + 16 : row.clientWidth * 0.8;
        row.scrollBy({ left: btn.hasAttribute('data-carousel-next') ? amount : -amount, behavior: 'smooth' });
      });
    });
  });

  /* ---------- Collection filters ---------- */
  var filterForm = document.querySelector('[data-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('change', function (e) {
      if (e.target.matches('[data-filter-submit-on-change]')) filterForm.submit();
    });
  }
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { revealObserver.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-revealed'); });
  }
})();
